function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgNotificationsScreenIcon = function SvgNotificationsScreenIcon(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 40,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement(Path, {
    stroke: props.fillLine,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.105,
    d: "M22.106 28.421v8.421A2.105 2.105 0 0 1 20 38.947H3.158a2.105 2.105 0 0 1-2.105-2.105V7.368a2.105 2.105 0 0 1 2.105-2.105H7.37"
  }), /*#__PURE__*/React.createElement(Path, {
    stroke: props.accentFillLine,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.105,
    d: "M11.58 32.632v.02m2.105-31.6h21.052v16.843h-6.315L20 22.105v-4.21h-6.316V1.053Z"
  }));
};
export default SvgNotificationsScreenIcon;